import React, { Component } from "react";
import _ from "lodash";
import "../styles/Item.css";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";

import "../styles/Address.css";

class Address extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    handleProvinceChange(event, value) {
        let target = { ...event.target };
        target.name = "province";
        target.value = value;
        event.target = target;
        this.handleChange(event);
    }

    handleChange(event) {
        this.props.handleChange(event);
    }

    isError(fieldName) {
        return this.props.address.validationErrors && this.props.address.validationErrors.some(ve => ve.fieldName.toUpperCase() === fieldName.toUpperCase());
    }

    getHelperText(fieldName) {
        return this.props.address.validationErrors && this.props.address.validationErrors.some(ve => ve.fieldName.toUpperCase() === fieldName.toUpperCase())
            ? //? this.props.address.validationErrors.filter(ve => ve.fieldName.toUpperCase() === fieldName.toUpperCase())[0].errorMessage
              "Invalid"
            : null;
    }

    render() {
        if (this.props.countryListLoading || this.props.provinceListLoading) {
            return (
                <div className="relative flex layout vertical">
                    <div className="loading-box fit layout vertical center-center">
                        <CircularProgress size={40} thickness={6} />
                    </div>
                </div>
            );
        }

        let country =
            this.props.address.country && this.props.countryList.length > 0
                ? this.props.countryList.filter(c => c.code === this.props.address.country.code)[0].label
                : "";

        return (
            <div className="flex layout vertical address-form address-box">
                <div className="flex layout vertical custom-textfield-inactive">
                    <p className="custom-textfield-inactive-label">{locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.COUNTRY.LABEL}</p>
                    <p className="custom-textfield-inactive-value">{country}</p>
                </div>
                <div className="flex layout horizontal first-name-last-name-box">
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("firstName")}
                            helperText={this.getHelperText("firstName")}
                            disabled={this.props.disabled}
                            value={this.props.address.firstName}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.FIRST_NAME.LABEL}
                            name="firstName"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "first_name"
                            }}
                            inputProps={{ id: "first_name", maxLength: 35 }}
                        />
                    </form>
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("lastName")}
                            helperText={this.getHelperText("lastName")}
                            disabled={this.props.disabled}
                            value={this.props.address.lastName}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.LAST_NAME.LABEL}
                            name="lastName"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "last_name"
                            }}
                            inputProps={{ id: "last_name", maxLength: 35 }}
                        />
                    </form>
                </div>
                <div className="flex layout horizontal">
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("address1")}
                            helperText={this.getHelperText("address1")}
                            disabled={this.props.disabled}
                            value={this.props.address.address1}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.ADDRESS_1.LABEL}
                            name="address1"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "address1"
                            }}
                            inputProps={{ id: "address1", maxLength: 35 }}
                        />
                    </form>
                </div>
                <div className="flex layout horizontal">
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("address2")}
                            helperText={this.getHelperText("address2")}
                            disabled={this.props.disabled}
                            value={this.props.address.address2}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.ADDRESS_2.LABEL}
                            name="address2"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "address2"
                            }}
                            inputProps={{ id: "address2", maxLength: 35 }}
                        />
                    </form>
                </div>
                <div className="flex layout horizontal city-province-postal-code-box">
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("city")}
                            helperText={this.getHelperText("city")}
                            disabled={this.props.disabled}
                            value={this.props.address.city}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.CITY.LABEL}
                            name="city"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "city"
                            }}
                            inputProps={{ id: "city", maxLength: 35 }}
                        />
                    </form>
                    {this.props.countryList.filter(c => c.code === this.props.address.country.code)[0] &&
                        this.props.countryList.filter(c => c.code === this.props.address.country.code)[0].provinces.sort((a, b) => b.name).length > 0 && (
                            <form
                                className="flex layout horizontal"
                                autoComplete="off"
                                onSubmit={e => {
                                    e.preventDefault();
                                }}
                            >
                                <Autocomplete
                                    disabled={this.props.disabled}
                                    className="flex layout vertical custom-autocomplete"
                                    disableClearable
                                    value={this.props.address.province}
                                    options={this.props.countryList.filter(c => c.code === this.props.address.country.code)[0].provinces.sort((a, b) => b.name)}
                                    getOptionLabel={option => option.name}
                                    renderInput={params => (
                                        <TextField
                                            autoComplete="off"
                                            error={this.isError("province")}
                                            helperText={this.getHelperText("province")}
                                            disabled={this.props.disabled}
                                            name="province"
                                            className="custom-textfield select"
                                            style={{ width: "unset" }}
                                            {...params}
                                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.PROVINCE.LABEL}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    )}
                                    onChange={this.handleProvinceChange.bind(this)}
                                />
                            </form>
                        )}
                    <form
                        className="flex layout horizontal"
                        autoComplete="off"
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <TextField
                            autoComplete="off"
                            error={this.isError("postalCode")}
                            helperText={this.getHelperText("postalCode")}
                            disabled={this.props.disabled}
                            value={this.props.address.postalCode}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.REPLACEMENT_ADDRESS.POSTAL_CODE.LABEL}
                            name="postalCode"
                            variant="outlined"
                            onChange={this.handleChange.bind(this)}
                            InputLabelProps={{
                                shrink: true,
                                htmlFor: "postal_code"
                            }}
                            inputProps={{ id: "postal_code", maxLength: 35 }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

export default Address;
